<div class="table-container">
  <div class="table">
    <div class="table-heading">
      <div class="table-item">{{ 'debates.opinions' | translate }}</div>
      <div class="table-item">{{ 'debates.datetime' | translate }}</div>
      <div class="table-item">{{ 'debates.vote' | translate }}</div>
      <div class="table-item">{{ 'debates.author' | translate }}</div>
    </div>
    <lms-debate-opinions-list-row *ngFor="let opinion of opinions" [opinion]="opinion"></lms-debate-opinions-list-row>
  </div>
</div>
